// API endpoints
export const API_ENDPOINTS = {
  // Jira endpoints
  JIRA: {
    FIND_LAST_TASK: '/api/find-last-task',
    LAST_TASK_NUMBER: '/api/last-task-number',
    WORKLOG_DATE_RANGE: '/api/worklog/date-range',
    WORKLOG_ALL: '/api/worklog',
    WORKLOG_SAVE: '/api/worklog/save',
    WORKLOG_RESTORE: '/api/worklog/restore',
    TEST_CONNECTION: '/api/jira/test',
    CREDENTIALS: '/api/jira-credentials',
  },
  // Firebase endpoints (будущие)
  FIREBASE: {
    AUTH: '/api/firebase/auth',
    DATA: '/api/firebase/data',
  },
  // GitHub endpoints (будущие)
  GITHUB: {
    REPOS: '/api/github/repos',
    COMMITS: '/api/github/commits',
  },
} as const;

// Быстрые фильтры дат
export const DATE_FILTERS = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'thisWeek',
  LAST_WEEK: 'lastWeek',
  THIS_MONTH: 'thisMonth',
  LAST_MONTH: 'lastMonth',
  THIS_QUARTER: 'thisQuarter',
  LAST_QUARTER: 'lastQuarter',
  THIS_YEAR: 'thisYear',
  LAST_YEAR: 'lastYear',
  CUSTOM: 'custom',
} as const;

// Статусы загрузки
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

// Форматы экспорта
export const EXPORT_FORMATS = {
  CSV: 'csv',
  XLSX: 'xlsx',
} as const;

// Буфер для поиска задач
export const TASK_SEARCH_BUFFER = 150;

// Максимальное количество задач для быстрого обновления
export const QUICK_UPDATE_LIMITS = {
  START_FROM: 4717,
  MAX_TASK: 5717,
} as const;
